import React from 'react'
import { I18n } from 'react-redux-i18n'
import CollapsablePlugin from 'components/common/CollapsablePlugin'
import usePluginTrackingUserInfo from './usePluginTrackingUserInfo'
import Nixi1Spinner from 'components/Nixi1Spinner'
import './styles.scss'

const PluginTrackingUserInfo = ({ userId }) => {
  const {
    isOpen, isEmpty, isLoading,
    trackingUserInfo, onClickCollapse
  } = usePluginTrackingUserInfo({ userId })

  if (!userId) return null

  return (
    <CollapsablePlugin
      isOpen={isOpen}
      onClickCollapse={onClickCollapse}
      title={I18n.t("dashboard_user_info")}
      icon="icon-user-dark"
    >
      <div className='tracking-user'>
        {
          isEmpty && isLoading ? (
            <div className="tracking-user__loading">
              <Nixi1Spinner width='15px' height='15px' />
            </div>
          ) : isEmpty ? (
            <div className="tracking-user__empty">
              {I18n.t('dashboard_no_user_info')}
            </div>
          ) :
            <>
              {
                Object.entries(trackingUserInfo.user).map((item) => {
                  const [key, value] = item
                  return value ? (
                    <div className="tracking-user__item" key={key}>
                      <div className="tracking-user__item--label">{I18n.t(`dashboard_${key}`)}: </div>
                      <div className="tracking-user__item--value">{value} </div>
                    </div>
                  ) : null
                })
              }
              <div className="tracking-user__separator">&nbsp;</div>
              {
                trackingUserInfo?.browsing && Object.entries(trackingUserInfo.browsing).map((item) => {
                  const [key, value] = item
                  return value ? (
                    <div className="tracking-user__item" key={key}>
                      <div className="tracking-user__item--label">{I18n.t(`dashboard_${key}`)}: </div>
                      <div className="tracking-user__item--value">{value} </div>
                    </div>
                  ) : null
                })
              }
              {
                trackingUserInfo?.variables.length > 0 && (
                  <>
                    <div className="tracking-user__separator">&nbsp;</div>
                    {trackingUserInfo.variables.map((variable) => {
                      return (
                        <div className="tracking-user__item" key={variable.label}>
                          <div className="tracking-user__item--label">{variable.label}: </div>
                          <div className="tracking-user__item--value">{variable.value} </div>
                        </div>
                      )
                    })
                    }
                  </>
                )
              }
            </>
        }
      </div>
    </CollapsablePlugin>
  )
}

export default PluginTrackingUserInfo
